import globalTheme, { muiTheme } from '../global'

const CssBaseline = {
	MuiCssBaseline: {
		styleOverrides: {
			MuiCssBaseline: {
				// styleOverrides: `
				//   @font-face {
				//     font-family: 'Raleway';
				//     font-style: normal;
				//     font-display: swap;
				//     font-weight: 400;
				//     src: "local('Raleway'), local('Raleway-Regular'), url(${RalewayWoff2}) format('woff2')";
				//     unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
				//   }
				// `,
			},
			html: {
				WebkitFontSmoothing: 'auto',
				fontSize: muiTheme.typography.htmlFontSize,
				height: '100%',
			},
			body: {
				color: globalTheme.palette.common.black,
				fontFamily: globalTheme.typography.body1.fontFamily,
				fontSize: globalTheme.typography.fontSize,
				lineHeight: 1.25,
				height: '100%',
				'& .grecaptcha-badge': { visibility: 'hidden' },
				[globalTheme.breakpoints.down('sm')]: {
					overflowY: 'overlay',
				},
				'& .d-none': {
					display: 'none !important',
				},
				'& .d-none-xs': {
					[globalTheme.breakpoints.down('xsm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xsm': {
					[globalTheme.breakpoints.down('sm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-sm': {
					[globalTheme.breakpoints.down('md')]: {
						display: 'none !important',
					},
				},
				'& .d-none-md': {
					[globalTheme.breakpoints.down('lg')]: {
						display: 'none !important',
					},
				},
				'& .d-none-lg': {
					[globalTheme.breakpoints.down('xl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xl': {
					[globalTheme.breakpoints.down('xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-xxl': {
					[globalTheme.breakpoints.down('xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xs': {
					[globalTheme.breakpoints.between('xs', 'xsm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xsm': {
					[globalTheme.breakpoints.between('xsm', 'sm')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-sm': {
					[globalTheme.breakpoints.between('sm', 'md')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-md': {
					[globalTheme.breakpoints.between('md', 'lg')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-lg': {
					[globalTheme.breakpoints.between('lg', 'xl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xl': {
					[globalTheme.breakpoints.between('xl', 'xxl')]: {
						display: 'none !important',
					},
				},
				'& .d-none-only-xxl': {
					[globalTheme.breakpoints.up('xxl')]: {
						display: 'none !important',
					},
				},
			},
		},
	},
}

export default CssBaseline
